const csmstimetable = {
  namespaced: true,
  state: {
    applyObj: {},
    online: {} //在线选课
  },
  mutations: {
    setApplyObj (state, applyObj) {//调代课申请的详情
      state.applyObj = applyObj;
    },
    setOnline (state,online) {//在线选课
      state.online = online;
    },
  },
}
export default csmstimetable

